export const QUERY_KEYS = {
  User: ['user'] as const,
} as const;
